module.exports = __webpack_public_path__ + "img/pic9.ba3052eb.png";